import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Table, Button } from "reactstrap";
import moment from "moment";

import staffService from "../../services/staffService";
import RequestAppointmentModal from "./RequestAppointmentModal";

const Welcome = () => {
  const user = useSelector((state) => state.authentication.user);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    staffService
      .getNotifications()
      .then((payload) => setNotifications(payload));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      staffService
        .getNotifications()
        .then((payload) => setNotifications(payload));
    }, 30000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const clearNotification = (evt) => {
    evt.preventDefault();
    const { value } = evt.target;
    staffService
      .clearNotification(value)
      .then(() =>
        staffService
          .getNotifications()
          .then((payload) => setNotifications(payload))
      );
  };

  const clearAllNotifications = (evt) => {
    evt.preventDefault();
    notifications.forEach((item, index, arr) => {
      let id = arr[index].staffNotificationId;
      staffService
        .clearNotification(id.toString())
        .then(() =>
          staffService
            .getNotifications()
            .then((payload) => setNotifications(payload))
        );
    });
  };
  const altClearNotification = (id) => {
    staffService.clearNotification(id).then(() =>
      staffService.getNotifications().then((payload) => {
        setNotifications(payload);
        document.querySelector("body").classList.remove("modal-open");
      })
    );
  };
  return (
    <Row>
      <Col xs={12}>
        <h2>Hi {user ? user.firstName : " "}!</h2>
        <p>Notifications.</p>
        <Button
          type="button"
          value={"clearAll"}
          color="danger"
          className="float-right"
          disabled={notifications.length > 0 ? false : true}
          onClick={(evt) => {
            clearAllNotifications(evt);
          }}
          style={{ marginBottom: "5px" }}
        >
          Clear all
        </Button>
        {notifications && (
          <Table size="sm" striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Description</th>
                <th>By</th>
                <th>Role</th>
                <th>Created on</th>
                <th>Clear</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map((n) => (
                <tr key={n.staffNotificationId}>
                  <th scope="row">{n.staffNotificationId}</th>
                  <td>
                    {(n.request && (
                      <RequestAppointmentModal
                        buttonLabel={n.description}
                        id={n.causedById}
                        clearNotification={altClearNotification}
                        target={n.staffNotificationId}
                      />
                    )) ||
                      n.description}
                  </td>
                  <td>{n.causedById}</td>
                  <td>{n.causedByRole}</td>
                  <td>
                    {moment(n.createdDate).format("ddd MMM-DD-YYYY hh:mm A")}
                  </td>
                  <td>
                    <Button
                      type="button"
                      value={n.staffNotificationId}
                      onClick={(evt) => {
                        clearNotification(evt);
                      }}
                    >
                      Clear
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Col>
    </Row>
  );
};

export default Welcome;
